export const NoPermissionMessage = `You don't have permissions to view this project. To change permissions
                                            please contact your account administrator.`;

export const NoPermissionMessagePortfolioPage = `You don't have permissions to view portfolio. To change permissions please contact your account administrator. `;
